import { InteractionRepositoryInterface } from '@foundation/blocks';
import { Interaction } from '@foundation/interactions/models';
import { InteractionsRepository } from '@foundation/interactions/state';
import { Interview } from '@spoken/interviews/models';
import { GenericRepository } from '@foundation/table/state';
import { AttrElement, isEqual } from '@foundation/utils';
import { inject, Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { of, switchMap, tap } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class InterviewsRepository extends GenericRepository<Interview> implements InteractionRepositoryInterface {
	interactionsRepository = inject(InteractionsRepository<Interview>);

	constructor() {
		super('interview');
	}

	public goToInterview(interviewId: string | null, extraParams?: NavigationExtras) {
		this._router.navigate(['/', 'host', 'dashboard', 'interviews', interviewId, 'builder'], extraParams);
	}

	saveInteraction(interviewId: string, datae: { blockId: string; stepId: string; propertyId: string; value: AttrElement }[]) {
		const interactionKey = `interview.${interviewId}`;

		console.log('[InterviewsRepository] (saveInteraction) you want to save this datae:', datae);

		// now, WE NEED TO SAVE THE VALUE
		const interaction$ = this.interactionsRepository.getOrCreateInteraction$(interactionKey).pipe(
			tap((interaction) => {
				console.log('[InterviewsRepository] (saveInteraction) interaction created or fetched:', interaction);
			})
		);
		interaction$
			.pipe(
				switchMap((interaction) => {
					let changed = false;
					if (interaction) {
						// loop through the datae and save each value
						datae.forEach((data) => {
							const { blockId, stepId, propertyId } = data;

							const propertyKey = `${interviewId}.${stepId}.${blockId}.${propertyId}`;

							if (isEqual(data.value, interaction.config[propertyKey])) {
								// console.log('[InterviewsRepository] (saveInteraction) value is the same :', data.value);
							} else {
								console.log('[InterviewsRepository] (saveInteraction) value is different:', data.value, interaction.config[propertyKey]);
								// update the value on the new interaction
								interaction.config[propertyKey] = data.value;
								changed = true;
							}
						});
					} else {
						console.warn('[InterviewsRepository] (saveInteraction) interaction not available: not saving');
						return of(null);
					}
					if (!changed) {
						// console.log('[InterviewsRepository] (saveInteraction) no value changed');
						return of(null);
					}
					return this.interactionsRepository.saveInteractionByToken$(interaction) ?? of(null);
				})
			)
			.subscribe();
	}

	/**
	 * Called by mother component to reload the value of an interaction in a block
	 * @param data
	 * @returns
	 */
	reloadInteractionValue$(data: { blockId: string; stepId: string; interviewId: string; propertyId: string }) {
		const { interviewId, blockId, stepId, propertyId } = data;
		const propertyKey = `${interviewId}.${stepId}.${blockId}.${propertyId}`;
		const interactionKey = `interview.${interviewId}`;
		return this.interactionsRepository.getOrCreateInteraction$(interactionKey).pipe(
			switchMap((interaction) => {
				const interactionValue = interaction.config[propertyKey];
				return of(interactionValue);
			})
		);
	}

	reloadInteractionValue(interaction: Interaction, data: { blockId: string; stepId: string; interviewId: string; propertyId: string }) {
		const { interviewId, blockId, stepId, propertyId } = data;
		const propertyKey = `${interviewId}.${stepId}.${blockId}.${propertyId}`;
		const interactionValue = interaction.config[propertyKey];
		return interactionValue;
	}

	/**
	//  * Safe save for a single step in an interview
	//  */
	// saveStep$(interviewId: string, stepId: string, stepData: any) {
	// 	// Get current interview to send timeUpdated for concurrency control
	// 	const currentInterview$ = this.store.getObjectById$$$(interviewId);
	// 	const currentInterview = currentInterview$.value;
	// 	const currentTimeUpdated = currentInterview?.timeUpdated;

	// 	return this._requestService.post$<{ updated: boolean; type: string; interviewId: string; interview: Interview }, any>('/api/interviews/steps/update', {
	// 		newData: {
	// 			type: 'step',
	// 			interviewId,
	// 			data: {
	// 				stepId,
	// 				stepData
	// 			},
	// 			timeUpdated: currentTimeUpdated
	// 		}
	// 	}).pipe(
	// 		tap((response) => {
	// 			if (response.result?.updated && !response.error) {
	// 				// Update local store optimistically
	// 				const currentInterview$ = this.store.getObjectById$$$(interviewId);
	// 				const currentInterview = currentInterview$.value;
	// 				if (currentInterview) {
	// 					const updatedInterview = { ...currentInterview };
	// 					if (!updatedInterview.config) updatedInterview.config = {};
	// 					if (!updatedInterview.config.dadStore) updatedInterview.config.dadStore = { canvases: {} };
	// 					if (!updatedInterview.config.dadStore.canvases) updatedInterview.config.dadStore.canvases = {};

	// 					updatedInterview.config.dadStore.canvases[stepId] = stepData;
	// 					// Update timeUpdated to reflect the save
	// 					updatedInterview.timeUpdated = new Date();
	// 					this.store.upsertObjectLocally(updatedInterview);
	// 					console.log('Step saved and inserted locally:', stepId);
	// 				}
	// 			} else if (response.result?.interview && !response.result?.updated) {
	// 				// Concurrency conflict - update local store with latest version from backend
	// 				console.log('Concurrency conflict detected, updating local store with latest version');
	// 				this.store.upsertObjectLocally(response.result.interview);
	// 			}
	// 		})
	// 	);
	// }

	// /**
	//  * Safe save for interview settings
	//  */
	// saveSettings$(interviewId: string, settings: any) {
	// 	// Get current interview to send timeUpdated for concurrency control
	// 	const currentInterview$ = this.store.getObjectById$$$(interviewId);
	// 	const currentInterview = currentInterview$.value;
	// 	const currentTimeUpdated = currentInterview?.timeUpdated;

	// 	return this._requestService.post$<{ updated: boolean; type: string; interviewId: string; interview: Interview }, any>('/api/interviews/steps/update', {
	// 		newData: {
	// 			type: 'settings',
	// 			interviewId,
	// 			data: settings,
	// 			timeUpdated: currentTimeUpdated
	// 		}
	// 	}).pipe(
	// 		tap((response) => {
	// 			if (response.result?.updated && !response.error) {
	// 				// Update local store optimistically
	// 				const currentInterview$ = this.store.getObjectById$$$(interviewId);
	// 				const currentInterview = currentInterview$.value;
	// 				if (currentInterview) {
	// 					const updatedInterview = { ...currentInterview };

	// 					// Update top-level interview properties
	// 					if ('title' in settings) updatedInterview.title = settings.title;
	// 					if ('enabled' in settings) updatedInterview.enabled = settings.enabled;

	// 					// Update config properties
	// 					if (!updatedInterview.config) updatedInterview.config = {};
	// 					if ('themeDetails' in settings) updatedInterview.config.themeDetails = settings.themeDetails;
	// 					if ('hideDefaultNavigation' in settings) updatedInterview.config.hideDefaultNavigation = settings.hideDefaultNavigation;

	// 					// Update timeUpdated to reflect the save
	// 					updatedInterview.timeUpdated = new Date();
	// 					this.store.upsertObjectLocally(updatedInterview);
	// 					console.log('Settings saved and inserted locally:', settings);
	// 				}
	// 			} else if (response.result?.interview && !response.result?.updated) {
	// 				// Concurrency conflict - update local store with latest version from backend
	// 				console.log('Concurrency conflict detected, updating local store with latest version');
	// 				this.store.upsertObjectLocally(response.result.interview);
	// 			}
	// 		})
	// 	);
	// }

	private _i18n_createNewInterviewSentence = this._translationService.prep('Give a name to your new interview:');
	public createNewInterview$() {
		return this._notificationService.prompt(undefined, this._i18n_createNewInterviewSentence()).closed.pipe(
			switchMap((promptResult: any) => {
				if (!promptResult) return of(null);
				const interviewTitle = promptResult.value;

				if (!interviewTitle) return of(null);

				const interviewId = uuidv4();

				return this.store.postObject$({
					id: interviewId,
					title: interviewTitle,
					enabled: true,
					config: {},
				});
			})
		);
	}
}
